// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"403b9715","130":"733bdbca","506":"733bdbca","540":"73920348","834":"733bdbca","875":"733bdbca","910":"733bdbca"}[chunkId] + ".chunk.css";
};